import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { siteInfo } from "@/mocks/site";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="flex w-full flex-col items-center justify-center px-4 py-24 text-center md:py-32">
        <span className="font-heading text-7xl font-black text-primary-500 md:text-9xl">404</span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这一瓜，好像没找到
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已被调整或链接有误。不如先回到首页，看看今天有哪些焦点事件值得一读。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/events"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-fire-line"></i>
            浏览热门事件
          </Link>
        </div>
        <nav className="mt-10 flex flex-wrap items-center justify-center gap-4 text-sm text-foreground-500">
          {siteInfo.nav.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="whitespace-nowrap transition-colors hover:text-primary-700"
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </SiteLayout>
  );
}